import { ColorVariantEnum } from 'obt-common/types/Flights/fareChangeBreakupNode';
import { NormalText, Row, SubText } from './styles';

interface IProps {
  label: string;
  value: string;
  colorVariant: ColorVariantEnum;
  subText: string;
  strikethroughValue?: boolean;
}

const NormalContent = ({ label, value, colorVariant, subText, strikethroughValue }: IProps) => {
  return (
    <>
      <Row>
        <NormalText colorVariant={colorVariant}>{label}</NormalText>
        <NormalText colorVariant={colorVariant} strikethroughValue={strikethroughValue}>
          {value}
        </NormalText>
      </Row>
      {!!subText && <SubText>{subText}</SubText>}
    </>
  );
};

export default NormalContent;
